const C = {
  name: "Dashboard",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 3C6.47715 3 2 7.47715 2 13V16C2 17.6569 3.34315 19 5 19H8.53513C9.22675 20.1956 10.5194 21 12 21C13.4806 21 14.7733 20.1956 15.4649 19H19C20.6569 19 22 17.6569 22 16V13C22 7.47715 17.5228 3 12 3ZM16 17C16 15.9759 15.6151 15.0416 14.9821 14.334L17.3868 10.7217L15.722 9.61343L13.3193 13.2227C12.9062 13.0784 12.4623 13 12 13C9.79086 13 8 14.7909 8 17H5C4.44772 17 4 16.5523 4 16V13C4 8.58172 7.58172 5 12 5C16.4183 5 20 8.58172 20 13V16C20 16.5523 19.5523 17 19 17H16ZM10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Dashboard
};
